(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './components/FileUploadStatusBox'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./components/FileUploadStatusBox'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.FileUploadStatusBox);
    global.index = mod.exports;
  }
})(this, function (exports, _FileUploadStatusBox) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _FileUploadStatusBox2 = _interopRequireDefault(_FileUploadStatusBox);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _FileUploadStatusBox2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/index.js
// module id = 887
// module chunks = 1